







import Vue from 'vue'

export default Vue.extend({
  props: {
    imagePath: {
      type: String,
      default: ''
    },
    paddingTop: {
      type: String,
      default: ''
    }
  },
  methods: {
    block() {
      return false
    }
  }
})
